module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNIj/T+TwlmGDVg1IBRA4aLAQC1HQofcivU+AAAAABJRU5ErkJggg=="